import React from 'react';

function Home() {
  return (
    <>
      <div className="homeDiv">
        <h2 className="h2">Welcome to our page!</h2>
        <p className="homePara">
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
          Praesentium omnis officia blanditiis laborum necessitatibus deserunt iusto,
          sapiente ipsa quibusdam expedita!
          Optio dolores sapiente esse rem doloribus voluptatibus aliquid repellat iure,
          reprehenderit totam, earum culpa.
          Nulla necessitatibus incidunt sunt culpa provident quo neque quae officiis.
          Voluptates libero cum totam dolore facilis laborum consequatur explicabo minus
          tempore exercitationem commodi sunt,
          culpa officiis illo quaerat soluta suscipit alias quas error nam, ad at esse?
          Consequatur voluptatem atque,
          architecto suscipit dolor soluta earum.
          Repellat nihil sapiente nobis hic ipsam,
          suscipit quos repellendus dignissimos cupiditate?
          Culpa autem repellendus voluptatibus repellat nemo eos qui reprehenderit fugit nulla,
          praesentium ut consequatur dicta delectus molestias debitis commodi
          possimus temporibus ea libero.
          Placeat consectetur mollitia iste eligendi,
          illo sequi quod ipsam minima debitis magni provident voluptates aspernatur
          quo inventore doloribus omnis accusantium.
          Itaque sapiente rem enim harum eum recusandae,
          perferendis deleniti quam ex,
          tenetur maiores facilis.
          Mollitia blanditiis tempore illo. Voluptatibus.
          Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          Molestias dolor error ut eius, saepe illum,
          quibusdam sunt accusantium officia sint corporis?
          Sapiente asperiores explicabo blanditiis in,
          beatae pariatur iusto architecto?
        </p>
      </div>
    </>
  );
}

export default Home;
